import { render, staticRenderFns } from "./create-investment-request.vue?vue&type=template&id=ab51622a&scoped=true&"
import script from "./create-investment-request.vue?vue&type=script&lang=js&"
export * from "./create-investment-request.vue?vue&type=script&lang=js&"
import style0 from "./create-investment-request.vue?vue&type=style&index=0&id=ab51622a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab51622a",
  null
  
)

export default component.exports